module.exports = __webpack_public_path__ + "img/dcCharge_online.b1fbc1d4.png";